



  document.addEventListener('DOMContentLoaded', function () {
    const icons = document.querySelectorAll('.quick_view_icon');
    const modal = document.getElementById('quick-view-modal');
    const modalContent = modal.querySelector('.modal-content');



    icons.forEach(icon => {
      icon.addEventListener('click', function () {
        const productHandle = this.getAttribute('data-handle');


        fetch(`/products/${productHandle}?view=quick-view`)
          .then(res => res.text())
          .then(html => {
            modalContent.innerHTML = html;
            modal.style.display = 'block';
          });
      });
    });

    // Close button
    document.addEventListener('click', function (e) {
      if (e.target.closest('.close-modal')) {
        modal.style.display = 'none';
        modalContent.innerHTML = ''; // Optional: clear old content
      }
    });






// Schedule Section Booked Form

let submitBtnClickedOnce = false;
let triggeredByCustomBtn = false;
let customCSSInjected = false;

function injectCustomCSS() {
  if (customCSSInjected) return; // একবারই inject হবে
  const style = document.createElement('style');
  style.innerHTML = `
    .servicify-modal-close {
      display: none !important;
    }
    .sc-fnGiBr.ipmnZO::after {
      position: absolute;
      right: 0.6%;
      top: 2%;
      content: "x";
      height: 27px;
      width: 28px;
      cursor: pointer;
      box-shadow: 0px 0px 5px 1px #ddd;
      display: grid;
      place-items: center;
      border-radius: 100px;
    }
  `;
  document.head.appendChild(style);
  customCSSInjected = true;
}








document.addEventListener('click', function(event) {
  const target = event.target;

  if (target && target.classList.contains('next_button_here')) {
    triggeredByCustomBtn = 'next';

    if (!submitBtnClickedOnce) {
      const submitBtn = document.querySelector('.product-form__submit');
      const overlay = document.querySelector('.ReactModal__Overlay');
      if (submitBtn) {
        submitBtn.click();
        submitBtnClickedOnce = true;
      }
      if (overlay) {
        overlay.classList.add('hide');
        overlay.style.opacity = '0';
        overlay.style.visibility = 'hidden';
      }
    }

    setTimeout(function() {
      const nextBtn = document.querySelector('.DayPicker-NavButton--next');
      if (nextBtn) {
        nextBtn.click();
      }
    }, 300);
  }

  else if (target && target.classList.contains('prev_button_here')) {
    triggeredByCustomBtn = 'prev';

    if (!submitBtnClickedOnce) {
      const submitBtn = document.querySelector('.product-form__submit');
      const overlay = document.querySelector('.ReactModal__Overlay');
      if (submitBtn) {
        submitBtn.click();
        submitBtnClickedOnce = true;
      }
      if (overlay) {
        overlay.classList.add('hide');
        overlay.style.opacity = '0';
        overlay.style.visibility = 'hidden';
      }
    }

    setTimeout(function () {
      const prevBtn = document.querySelector('.DayPicker-NavButton--prev');
      if (prevBtn) {
        prevBtn.click();
      }
    }, 300);
  }

  else if (target && target.classList.contains('product-form__submit')) {
    injectCustomCSS(); // submit button click হলে css যোগ হবে
    if (!triggeredByCustomBtn) {
      const overlay = document.querySelector('.ReactModalPortal .ReactModal__Overlay');
      if (overlay) {
        overlay.style.opacity = '1';
        overlay.style.visibility = 'visible';
      }
    }
    triggeredByCustomBtn = false;
  }

  else if (
    target && (
      target.classList.contains('DayPicker-NavButton--next') ||
      target.classList.contains('DayPicker-NavButton--prev')
    )
  ) {
    setTimeout(function() {
      const captionDiv = document.querySelector('.DayPicker-Caption > div');
      if (captionDiv) {
        const text = captionDiv.textContent.trim();
        const parts = text.split(' ');
        if (parts.length >= 2) {
          const month = parts[0];
          const year = parts[1];

          const yearElem = document.querySelector('.year_num');
          if (yearElem) {
            yearElem.innerHTML = year;
          }

          const themonth = document.querySelector('.month_num');
          if (themonth) {
            themonth.innerHTML = month;
          }
        }
      }
    }, 100);
  }

  if (target && target.classList.contains('avilablity_num')) {
    injectCustomCSS(); // availability number click হলে css যোগ হবে
    setTimeout(function () {
      const overlay = document.querySelector('.ReactModalPortal .ReactModal__Overlay');
      if (overlay) {
        overlay.style.opacity = '1';
        overlay.style.visibility = 'visible';
      }
    }, 300);
  }

  if (
    target &&
    target.classList.contains('sc-fnGiBr') &&
    target.classList.contains('ipmnZO')
  ) {
    setTimeout(function () {
      const overlay = document.querySelector('.ReactModalPortal .ReactModal__Overlay');
      if (overlay) {
        overlay.style.opacity = '0';
        overlay.style.visibility = 'hidden';
      }
    }, 300);
  }
});














});



// const interval = setInterval(() => {
//   const chat = document.querySelector("#shopify-chat");
//   if (chat) {
//     clearInterval(interval);
//     alert("#shopify-chat is now in the DOM!");
//   }
// }, 500); // প্রতি 0.5 সেকেন্ডে চেক করবে


window.addEventListener("load", () => {
  setTimeout(() => {
    const checkInterval = setInterval(() => {
      const chat = document.querySelector("#shopify-chat inbox-online-store-chat");
      const contactDiv = document.querySelector(".contact_div");
      const showBtn = document.querySelector(".show_btn");
      const showBtns = document.querySelector(".show_btns");
      const closeBtn = document.querySelector(".close_button");
      const Shopifylivechatarea = document.querySelector("#ShopifyChat");

      if (chat && chat.shadowRoot && contactDiv && showBtn && closeBtn) {
        const chatToggle = chat.shadowRoot.querySelector(".chat-toggle");
        const closeChatBtn = chat.shadowRoot.querySelector(".chat-app--close-button");

        // page load এ hidden
        if (chatToggle) chatToggle.style.visibility = "hidden";
        if (closeChatBtn) closeChatBtn.style.visibility = "hidden";

        // contactDiv click করলে open/close toggle
contactDiv.addEventListener("click", () => {
  const freshChatToggle = chat.shadowRoot.querySelector(".chat-toggle");
  const freshCloseChatBtn = chat.shadowRoot.querySelector(".chat-app--close-button");


  if (contactDiv.classList.contains("open")) {
    // আগে open থাকলে close করা
    if (freshCloseChatBtn) freshCloseChatBtn.click();

    showBtn.style.display = "block";
    showBtns.style.display = "block";
    closeBtn.classList.remove("show");
    contactDiv.style.left = "";
    contactDiv.classList.remove("open");
  } else {
    // open করার সময়
    if (freshChatToggle) freshChatToggle.click();

    showBtn.style.display = "none";
    showBtns.style.display = "none";
    closeBtn.classList.add("show");
    contactDiv.style.left = "-1%";
    contactDiv.classList.add("open");

    if (Shopifylivechatarea) {
      Shopifylivechatarea.style.marginLeft = "3%";
    }
  }


});

  // const close_button = chat.shadowRoot.querySelector("button[name='closeChat']");

  //   close_button.addEventListener("click", () => {
  //     alert('hi');
  //   showBtn.style.display = "block";
  //   showBtns.style.display = "block";
  //   closeBtn.classList.remove("show");
  //   contactDiv.style.left = "";
  //   contactDiv.classList.remove("open");
  // });

 function bindCloseButton(chat, showBtn, showBtns, closeBtn, contactDiv) {
  const freshCloseBtn = chat.shadowRoot.querySelector("button[name='closeChat']");
  if (freshCloseBtn && !freshCloseBtn.dataset.bound) {
    freshCloseBtn.dataset.bound = "true"; // যেন বারবার bind না হয়
    freshCloseBtn.addEventListener("click", () => {
      showBtn.style.display = "block";
      showBtns.style.display = "block";
      closeBtn.classList.remove("show");
      contactDiv.style.left = "";
      contactDiv.classList.remove("open");
    });
  }
}

setInterval(() => {
  const chat = document.querySelector("#shopify-chat inbox-online-store-chat");
  const showBtn = document.querySelector(".show_btn");
  const showBtns = document.querySelector(".show_btns");
  const closeBtn = document.querySelector(".close_button");
  const contactDiv = document.querySelector(".contact_div");

  if (chat && chat.shadowRoot) {
    bindCloseButton(chat, showBtn, showBtns, closeBtn, contactDiv);
  }
}, 1000); // প্রতি ১ সেকেন্ডে চেক করবে




window.addEventListener("click", () => {
  const checkToggle = chat.shadowRoot.querySelector(".chat-toggle");
  const checkClose = chat.shadowRoot.querySelector(".chat-app--close-button")

  if (checkClose) {
    checkClose.style.visibility = "hidden";
  } else if (checkToggle) {
    checkToggle.style.visibility = "hidden";
  } 
});




        // Close button click হলে open button hide
        if (closeBtn) {
          closeBtn.addEventListener("click", () => {
            if (showBtn) showBtn.style.display = "none";
            if (showBtns) showBtns.style.display = "none";
          });
        }

        clearInterval(checkInterval);
      }




    }, 500);
    
  }, 100);
});



